import { render, staticRenderFns } from "./RiskRatingTable.vue?vue&type=template&id=3c7ce742&scoped=true"
import script from "./RiskRatingTable.vue?vue&type=script&lang=js"
export * from "./RiskRatingTable.vue?vue&type=script&lang=js"
import style0 from "./RiskRatingTable.vue?vue&type=style&index=0&id=3c7ce742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ce742",
  null
  
)

export default component.exports